import React from 'react'
import './css/app.scss'
import { HashRouter } from 'react-router-dom'
import Routes from './routes'
import { DarkModeProvider } from './providers/DarkModeContext'

const App = () =>
{    
    return (
        <div className="App">
            <DarkModeProvider>
                <HashRouter>
                    <Routes />
                </HashRouter>
            </DarkModeProvider>
        </div>
    )
}

export default App
